module.exports = __webpack_public_path__ + "img/logo.699990df.png";